(function () {
  function formatEUR(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
    });
  }

  function updateBar(bar, total) {
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    var remaining = threshold - total;
    var reached = remaining <= 0;
    var percent = threshold > 0 ? Math.min(100, Math.round((total * 100) / threshold)) : 0;

    bar.classList.toggle('veizu-freeship--reached', reached);

    var fill = bar.querySelector('[data-freeship-fill]');
    if (fill) fill.style.width = percent + '%';

    var text = bar.querySelector('[data-freeship-text]');
    if (text) {
      text.innerHTML = reached
        ? 'Geschafft – dein Versand ist kostenlos!'
        : 'Noch <strong>' + formatEUR(remaining) + '</strong> bis zum kostenlosen Versand';
    }
  }

  function refreshAll() {
    var bars = document.querySelectorAll('[data-veizu-freeship]');
    if (!bars.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bars.forEach(function (b) { updateBar(b, cart.total_price); });
      })
      .catch(function () {});
  }

  function init() {
    refreshAll();

    var notification = document.getElementById('cart-notification') ||
      document.querySelector('cart-notification');
    if (!notification) return;

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        refreshAll();
      }, 50);
    });
    observer.observe(notification, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
